module.exports = "/assets/gift-events-listing/BF24-banner-comparison-desktop.png?sCGq5DJ";